var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextInput2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V2H0V0ZM0 4H10V6H0V4Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput2);
export default __webpack_public_path__ + "static/media/text-input-2.9db943a1bb29252d2e22072bce020c67.svg";
export { ForwardRef as ReactComponent };